export enum AssignmentMethodEnum {
    manual,
    roundRobin,
    territoryBased,
    workloadBalanced,
    bulkReassign
}
